// Full-screen blocking state shown when the native build is below the
// server's min_supported_build (the in-field kill switch for broken builds).
import { RefreshCw } from "lucide-react";
import { useT } from "../lib/i18n";

const APP_STORE_URL = "https://apps.apple.com/app/id6795866981";

export function UpdateRequired() {
  const t = useT();
  return (
    <div className="min-h-screen-d flex flex-col items-center justify-center text-fg px-8 text-center gap-4">
      <span className="w-14 h-14 rounded-2xl bg-brand flex items-center justify-center">
        <RefreshCw size={26} className="text-on-brand" aria-hidden="true" />
      </span>
      <h1 className="text-xl font-semibold">{t("update.title")}</h1>
      <p className="text-sm text-fg-muted leading-relaxed max-w-xs">{t("update.body")}</p>
      <a
        href={APP_STORE_URL}
        className="mt-2 px-6 py-3 bg-brand text-on-brand rounded-full font-semibold press"
      >
        {t("update.cta")}
      </a>
    </div>
  );
}
